
import axios from 'axios'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import Group from 'model/Group'
import { Facility } from 'model/UserSession'

const { server } = (window as any).config

export class GroupRepository extends WebRepository<Group> {
  constructor() {
    super(new Api('groups'))
  }

  /**
   * Every configured facility, not just the ones the caller has patients in — an
   * admin has to be able to stamp a group at a site where they personally have
   * none. Admin-gated server-side.
   */
  async findAllFacilities(): Promise<Facility[]> {
    axios.defaults.withCredentials = true
    const res = await axios.get(`${server}/groups/facilities`)
    return res.data?.facilities ?? []
  }
}

export default new GroupRepository()
